export const initialView = {
  latitude: 37.7577,
  longitude: -95.4376,
  zoom: 5
};
